export const DEFAULT_PROFILE_PIC = './assets/pictures/defaultProfile.svg';
export const CAMERA = './assets/pictures/camera-icon.png';
export const DEFAULT_AVATAR = './assets/pictures/avatar.svg';
